import { h } from "omi";

export function HelloGraphic() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="152" height="98" fill="none">
      <path
        d="M57.9581 52.9111c.2246.1719-.4887-.6412-.5879-.6281-.5483-.3306-1.0966-.6612-1.7309-.8796-1.7178-.7805-3.5348-1.5478-5.4245-2.1037M60.8129 37.1981c.086-.1123-.1525 1.1299-.1261 1.3282-.0797.9185-.1462 1.9361-.2128 2.9538-.0872 3.1388.5063 6.0863 1.9787 8.8161M68.7112 49.5654c-.2246-.1719-.0389-1.8107-.0652-2.0089.1794-2.445.7818-4.7444 2.1175-6.8386"
        stroke="#1B1918"
        stroke-width="3"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M10.5789 80.4932c14.2494-5.1218 35.0841-64.6857 18.4243-63.2787-16.9704 1.3474-2.4807 83.0505 4.1843 73.9937 3.339-4.479-3.4661-23.0443 3.6587-25.6052 8.7308-3.3796 3.4509 27.4849 15.8031 24.0275 6.609-1.8871.1043-12.1193 8.3797-16.649"
        stroke="#1B1918"
        stroke-width="3"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M61.1614 72.4595c2.9663 1.8252 14.8594-9.6416 10.5593-13.9123-8.7125-8.6274-20.9831 35.6752 2.1685 28.4624 16.8531-5.2661 23.9103-66.0254 13.5614-64.9527-10.448 1.0859-12.0699 54.1622 3.4103 60.5787 17.0861 7.1112 36.4911-63.9648 17.4791-62.0434-14.5389 1.4278-6.604 50.5102 4.99 59.5618 3.382 2.6777 11.305 2.3309 11.329-5.8434"
        stroke="#1B1918"
        stroke-width="3"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M145.162 47.1729c-3.584 6.4283-5.333 16.0424-12.484 18.4051-8.103 2.7918-11.362-9.5867-4.415-12.7293 10.073-4.6676 14.639 25.8972 2.81 26.4604-10.13.4384-5.082-13.952-6.686-19.1864"
        stroke="#1B1918"
        stroke-width="3"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}
